const closeBanner = () => {

    const bannersCollection = document.getElementsByClassName('js-closing-banner');

    if (bannersCollection.length < 1) {
        return;
    }

    const closeThatBanner = (banner) => {
        banner.style.display = 'none';
    };

    Array.from(bannersCollection).forEach((elem) => {
        const btn = elem.getElementsByClassName('js-close-btn')[0];
        btn.addEventListener('click', (event) => {
            event.stopPropagation();
            closeThatBanner(elem);
        });
    });

};

export default closeBanner;
